import './profile-form.scss';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, FormProvider } from 'react-hook-form';
import * as yup from 'yup';
import { useCallback } from 'react';
import TextField from '../../form-fields/text-field';
import PhoneField from '../../form-fields/phone-field';
import PasswordField from '../../form-fields/password-field';
import PrimaryButton from '../../buttons/primary-button/primary-button';
import {
  YUP_EMAIL_SCHEMA,
  YUP_FIRST_NAME_SCHEMA,
  YUP_LAST_NAME_SCHEMA,
  YUP_PHONE_SCHEMA,
} from '../../../../utilities/form';
import { requiredFieldMessages } from '../../../../utilities/messages';

const schema = yup
  .object({
    firstName: YUP_FIRST_NAME_SCHEMA,
    lastName: YUP_LAST_NAME_SCHEMA,
    phoneNumber: YUP_PHONE_SCHEMA.required(requiredFieldMessages.phone_number),
    email: YUP_EMAIL_SCHEMA,
    password: yup.string(),
  })
  .required();

const ProfileForm = ({
  defaultValues, onSubmit, submitting,
}) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues,
  });

  const onCancel = useCallback(() => {
    methods.reset(defaultValues);
  }, [defaultValues, methods]);

  return (
    <div className="profile-form">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="profile-form__content">
            <div className="profile-form__section">
              <div className="profile-form__section__title">
                <h4>General</h4>
              </div>

              <div className="profile-form__section__form">
                <TextField
                  name="firstName"
                  label="First name *"
                />
                <TextField
                  name="lastName"
                  label="Last name *"
                />
                <PhoneField name="phoneNumber" label="Phone *" />
              </div>
            </div>

            <div className="profile-form__section">
              <div className="profile-form__section__title">
                <h4>Login details</h4>
              </div>

              <div className="profile-form__section__form">
                <TextField
                  name="email"
                  label="Email *"
                  type="email"
                />
                <PasswordField
                  name="password"
                  label="Password"
                  placeholder="*************"
                  variant="link"
                  link="/profile/edit-password"
                />
              </div>
            </div>

            <div className="profile-form__actions">
              <button
                type="button"
                className="button button--default"
                onClick={onCancel}
                disabled={!methods.formState.isDirty || submitting}
              >
                Cancel
              </button>

              <PrimaryButton
                isLoading={submitting}
                disabled={!methods.formState.isDirty || !methods.formState.isValid}
                title="Save changes"
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default ProfileForm;
